import { mapDashboardScenarioItem, mapDashboardFiles } from 'common/helpers';
import { dashboardService as service } from 'services/serviceStorage';
import { wrapRequest } from "common/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BaseApiResponse } from 'common/types';
import {
    ScenariosFilter,
    Scenario,
    MappedScenario,
    MappedFile,
    FetchRowsParams,
    FetchRowsResponse,
    DumpFileComparisonParams
} from './types';


export const fetchScenarios = createAsyncThunk<MappedScenario[], ScenariosFilter>(
    'comparerDshb/fetchScenarios',
    async (filter) => {
        const { data } = await wrapRequest<BaseApiResponse<Scenario[]>>({
            handler: () => service.getScenarios(filter),
            showNotifications: true
        });

        const mappedData = data?.result.map(mapDashboardScenarioItem) || [];

        return mappedData;
    }
);

export const fetchFiles = createAsyncThunk<{ data: MappedFile[], total: number }, { sourceId: number; targetId: number }>(
    'comparerDshb/fetchFiles',
    async (filter) => {
        const { data } = await wrapRequest<BaseApiResponse<File[]>>({
            handler: () => service.getComparedFiles(filter),
            showNotifications: true
        });

        const mappedData = {
            data: mapDashboardFiles(data?.result),
            total: data?.result.length || 0,
        }

        return mappedData;
    }
);

export const fetchRows = createAsyncThunk<FetchRowsResponse, FetchRowsParams>(
    'comparerDshb/fetchRows',
    async (filter) => {
        const { data } = await wrapRequest<BaseApiResponse<{ content: string; queryExecutionId: string; nextToken: string | null }>>({
            handler: () => service.getComparedRows(filter),
            showNotifications: true
        });

        const mappedData: FetchRowsResponse = {
            data: data?.result.content ? JSON.parse(data.result.content) : [],
            queryExecutionId: data?.result.queryExecutionId || '',
            nextToken: data?.result.nextToken || null,
            filter: filter
        }

        return mappedData;
    }
);

export const loadScenarios = createAsyncThunk<void, { scenarioIds: number[]; dashboardIds: number[] }>(
    'comparerDshb/loadScenarios',
    async ({ scenarioIds, dashboardIds }, { rejectWithValue }) => {
        const err = await wrapRequest<BaseApiResponse<void>>({
            handler: () => service.loadScenarios({ scenarioIds: scenarioIds, dashboards: dashboardIds }),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);

export const dumpFileComparison = createAsyncThunk<string, DumpFileComparisonParams>(
    'comparerDshb/dumpFileComparison',
    async (filter) => {
        const { data } = await wrapRequest<BaseApiResponse<string>>({
            handler: () => service.dumpFileComparison(filter),
            showNotifications: true
        });

        return data!.result;
    }
);